<div class="delivery-dialog">
    <!-- Header -->
    <div class="dialog-header">
        <h2>📍 Delivery Location</h2>
        <p class="subtitle">Enter your delivery address to check availability</p>
        <!-- <button mat-icon-button class="close-btn" mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button> -->
    </div>

    <div mat-dialog-content class="dialog-content">
        <!-- Search Section -->
        <div class="search-section">
            <div class="search-container">
                <!-- <mat-icon class="search-icon">search</mat-icon> -->
                <input type="text" class="search-input" placeholder="Search for your area, landmark, or pincode"
                    autocorrect="off" autocapitalize="off" spellcheck="false" #search [disabled]="!newDeliveryDetails"
                    (input)="onSearchInput(search.value)" (keydown.enter)="$event.preventDefault()" />

                <button *ngIf="searchInput" class="clear-btn" (click)="clearSearch()" aria-label="Clear">
                    <!-- <mat-icon>close</mat-icon> -->
                    <lucide-icon name="x"></lucide-icon>
                </button>

                <button class="gps-btn" (click)="fetchCurrentLoc()" aria-label="Current location"
                    matTooltip="Use my current location">
                    <!-- <mat-icon>my_location</mat-icon> -->
                    <lucide-icon name="locate"></lucide-icon>
                </button>
            </div>
        </div>

        <!-- Map Section -->
        <div class="map-section">
            <div class="map-wrapper">
                <!-- <agm-map [latitude]="latitudeMap" 
                         [longitude]="longitudeMap" 
                         [zoom]="zoom">
                    <agm-marker [latitude]="latitudeMap" 
                                [longitude]="longitudeMap"
                                [markerDraggable]="newDeliveryDetails" 
                                (dragEnd)="markerDragEnd($event)">
                    </agm-marker>
                </agm-map> -->

                <google-map height="400px" width="100%" [center]="center" [zoom]="zoom">
                    <map-marker [position]="markerPosition" [options]="markerOptions"
                        (mapDragend)="markerDragEnd($event)">
                    </map-marker>
                </google-map>

                <!-- Map Overlay Info -->
                <div class="map-overlay" *ngIf="!newDeliveryDetails">
                    <mat-icon class="lock-icon">lock</mat-icon>
                    <span>Enable delivery to interact with map</span>
                </div>
            </div>
        </div>

        <!-- Toast Message -->
        <div *ngIf="showToast" class="toast-message">
            <mat-icon class="warning-icon">warning</mat-icon>
            <span>Delivery to pincode <strong>{{ pincode }}</strong> is currently not available</span>
        </div>

        <!-- Preferred Locations -->
        <div *ngIf="!showClickButton" class="locations-section">
            <div class="section-header">
                <h3>📍 Preferred Locations</h3>
                <span class="location-count">{{ locationSetupList.length }} saved</span>
            </div>

            <div class="locations-grid">
                <div *ngFor="let locationSetup of locationSetupList; let i = index" class="location-card"
                    [class.selected]="i === selectedIndex" (click)="onSelectLocation(i)">

                    <div class="location-content">
                        <div class="location-icon">
                            <!-- <mat-icon>location_on</mat-icon> -->
                            <lucide-icon name="map-pin"></lucide-icon>
                        </div>
                        <div class="location-details">
                            <div class="location-name">{{ locationSetup.locationName }}</div>
                            <div *ngIf="locationSetup.address1" class="address">{{ locationSetup.address1 }}</div>
                            <div *ngIf="locationSetup.address2" class="address">{{ locationSetup.address2 }}</div>
                            <div *ngIf="locationSetup.pincode" class="pincode">PIN: {{ locationSetup.pincode }}</div>
                            <div *ngIf="locationSetup.distance" class="distance">
                                <!-- <mat-icon class="distance-icon">directions_walk</mat-icon> -->
                                <lucide-icon name="footprints" class="distance-icon"></lucide-icon>
                                {{ locationSetup.distance }} km away
                            </div>
                        </div>
                        <div class="selection-indicator" *ngIf="i === selectedIndex">
                            <!-- <mat-icon class="check-icon">check_circle</mat-icon> -->
                            <lucide-icon name="circle-check" class="check-icon"></lucide-icon>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Actions -->
    <div mat-dialog-actions class="dialog-actions">
        <button mat-button mat-dialog-close class="cancel-btn">Cancel</button>
        <button mat-button class="continue-btn" [disabled]="!selectedOption" (click)="onContinueClick(selectedOption)">
            <span>Continue</span>
            <!-- <mat-icon>arrow_forward</mat-icon> -->
        </button>
    </div>
</div>